/**
 * Tour Sequences Configuration
 *
 * Defines sequences of tours that should play in order.
 * Used when triggering tours from Help Center buttons in new tabs.
 */

import type { TourSequence } from './types';

export const DEFAULT_SEQUENCE_ID = 'full-tour';

export const TOUR_SEQUENCES: Record<string, TourSequence> = {
  [DEFAULT_SEQUENCE_ID]: {
    id: DEFAULT_SEQUENCE_ID,
    name: 'Full Tour',
    tours: [
      'top-widget',
      'sidebar',
      'audit-landing',
      'audit-dashboard',
      'action-details',
      'performance-assessment',
      'reports-analytics-chart',
      'reports-analytics-table',
      'rate-card-landing',
      'rate-card-provider-selection',
      'rate-card-table',
      'rate-card-charges',
    ],
    targetPath: '/',
    stopAfterLast: true,
  },
  'navigation-sequence': {
    id: 'navigation-sequence',
    name: 'Navigation Tour',
    tours: ['top-widget', 'sidebar'],
    targetPath: '/',
    stopAfterLast: true,
  },
  'audit-sequence': {
    id: 'audit-sequence',
    name: 'Audit Exceptions Tour',
    tours: ['audit-landing', 'audit-dashboard'],
    targetPath: '/',
    stopAfterLast: true,
  },
  'action-details-sequence': {
    id: 'action-details-sequence',
    name: 'Action Details Tour',
    tours: ['action-details'],
    targetPath: '/',
    stopAfterLast: true,
  },
  'performance-sequence': {
    id: 'performance-sequence',
    name: 'Performance Assessment Tour',
    tours: ['performance-assessment'],
    targetPath: '/performance',
    stopAfterLast: true,
  },
  'reports-analytics-sequence': {
    id: 'reports-analytics-sequence',
    name: 'Reports & Analytics Tour',
    tours: ['reports-analytics-chart', 'reports-analytics-table'],
    targetPath: '/analytics',
    stopAfterLast: true,
  },
  'rate-card-manager-sequence': {
    id: 'rate-card-manager-sequence',
    name: 'Rate Card Manager Tour',
    tours: ['rate-card-table', 'rate-card-charges'],
    targetPath: '/ratecard-manager',
    stopAfterLast: true,
  },
};

/**
 * Get a tour sequence by ID
 */
export const getTourSequence = (sequenceId: string): TourSequence | undefined => TOUR_SEQUENCES[sequenceId];

/**
 * Check if a tour ID is part of any sequence
 */
export const isTourInSequence = (tourId: string, sequenceId: string): boolean => {
  const sequence = TOUR_SEQUENCES[sequenceId];
  return sequence ? sequence.tours.includes(tourId) : false;
};
